<template>
    <div :class="$style.container">
        <ul :class="$style.top">
            <li v-for="(item, index) in tags" :key="item"
                :class="index === (tags.length -1) ? $style.active: ''"
            >{{item}}
                <i :class="['iconfont', 'icon-rightarrow2f', $style.arrow]"
                   v-if="index < (tags.length -1)"
                ></i>
            </li>
        </ul>
        <h4 :class="$style.title">
            <p :class="$style.name">{{data.campaign_name}}</p>
            <div style="margin-bottom: 10px">

                <el-button :type="cusApproval" @click.stop="handleApprovalClick" v-if="btnApproval" size="small" :disabled="disabled">审批</el-button>
                <el-button :type="cusRecall" @click.stop="handleRecallClick" v-if="btnRecall" size="small" :disabled="disabled">撤回</el-button>
                <el-button type="success" @click.stop="handleCompleteClick" v-if="complete" size="small"
                           :disabled="disabled">完成</el-button>
                <el-button type="success" @click.stop="handleAgreeClick" v-if="btnAgree" size="small" :disabled="disabled">同意</el-button>
                <el-button type="danger" @click.stop="handleRefuseClick" v-if="btnRefuse" size="small" :disabled="disabled">拒绝</el-button>
                <el-button type="danger" @click.stop="handleRepealClick" v-if="btnRepeal" size="small" :disabled="disabled">撤销</el-button>
                <el-button type="warning" @click.stop="handleCalculateDataClick" v-if="btnCalculateData" size="small" :disabled="disabled">重新计算统计数据</el-button>
                <el-button type="warning" @click.stop="handleSubmitClick" v-if="btnSubmit" size="small"
                           :disabled="disabled" id="submit">提交</el-button>
                <el-button :type="cusSave" @click.stop="handleSaveClick" v-if="btnSave" size="small" :disabled="disabled">保存</el-button>
                <el-button type="danger" @click.stop="handleDeleteClick" v-if="btnDelete" size="small"
                           :disabled="disabled" id="delete" style="margin-right: 20px">删除</el-button>
                <el-button type="success" @click.stop="handleAddClick" v-if="btnAdd" size="small" class="icon">
                    <i :class="['iconfont', 'el-icon-plus', $style.back]" style="position: relative;top:1px"></i>
                    新增</el-button>
                <el-button type="danger" @click.stop="handleBackClick" v-if="btnBack" size="small" style="margin-left: 30px" class="icon">
                    <i :class="['iconfont', 'icon-back', $style.back]" style="position: relative;top:1px"></i>
                    返回</el-button>
            </div>
        </h4>
        <div :class="$style.box">
            <div :class="$style.boxContent">
                <p :class="$style.level"> {{data | filterDate}}
                    <span
                        :class="$style.site">
                    {{data.address}}</span></p>
                <p :class="$style.level"><span :class="$style.clientele">计划参会人数：{{data.planned_participants}}</span></p>
            </div>

            <div :class="$style.dataStatus" style="width: 500px">
                <p>{{data.activity_date | filterDateMonth}}</p>
                <ul style="margin-left: 160px;margin-top: -32px;width: 100px;height:auto;min-height: 10px">
                    <li style="margin-top: 10px;width: 400px" v-for="item,i in data.array">

                        <span :style="{'color':item.checkin_time !=='' ? '#FF9901' : '#ED3B3F'}"
                           >{{item | filterArray}}
                        </span>
                        <span :style="{'color':item.checkout_time !=='' ? '#FF9901' : '#ED3B3F'}"
                              style="margin-left: 10px"
                                >{{item | filterArrayOut}}</span>
                    </li>
                    <li style="margin-top: 10px;width: 400px" v-if="isShow()">
                        <span :style="{'color':'#ED3B3F'}"
                           >尚未签入
                        </span>
                        <span :style="{'color':'#ED3B3F'}"
                              style="margin-left: 10px"
                                >尚未签出</span>

                    </li>

                </ul>
            </div>

        </div>
    </div>
</template>
<script>
    import http from '../APIService/http'
    import moment from 'moment'
    export default {
        props: {
            tags: {
                type: Array,
                default: () => []
            },
            title: {
                type: String,
                default: ''
            },
            subTitle: {
                type: String,
                default: ''
            },
            cusApproval: {
                type: String,
                default: 'info'
            },
            cusSubmit: {
                type: String,
                default: 'info'
            },
            cusRecall: {
                type: String,
                default: 'info'
            },
            cusSave: {
                type: String,
                default: 'primary'
            },
            btnSubmit: {
                type: Boolean,
                default: false
            },
            btnApproval: {
                type: Boolean,
                default: false
            },
            btnRecall: {
                type: Boolean,
                default: false
            },
            btnAgree: {
                type: Boolean,
                default: false
            },
            btnRefuse: {
                type: Boolean,
                default: false
            },
            btnRepeal: {
                type: Boolean,
                default: false
            },
            btnSave: {
                type: Boolean,
                default: false
            },
            btnDelete: {
                type: Boolean,
                default: false
            },
            btnBack: {
                type: Boolean,
                default: false
            },
            btnAdd: {
                type: Boolean,
                default: false
            },
            btnCalculateData: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object,
                default: {}
            },
            complete: {
                type: Boolean,
                default : false
            }
        },
        filters:{
            filterDate:function (date) {
                let str = ''
                str = moment(date.start_time).format('YYYY年M月D日 HH:mm') + ' - ' +
                    moment(date.end_time).format('YYYY年M月D日 HH:mm')
                return str
            },
            filterDateMonth:function (date) {

                return moment(date).format('YYYY年M月D日')
            },
            filterArray:function (item) {
                if (item.checkin_time){
                    return '签入' + moment(item.checkin_time).format('HH:mm:ss')
                }else {
                    return '尚未签出'
                }
            },
            filterArrayOut:function (item) {
                if (item.checkout_time){
                    return '签出' + moment(item.checkout_time).format('HH:mm:ss')
                }else {
                    return '尚未签出'
                }
            },

        },
        mounted(){
        },
        created(){

            let item= JSON.parse(JSON.stringify(this.form));
            this.getCheckListById(item)
        },
        methods: {

            isShow(){

                if (this.data.array === undefined){
                    return true
                } else {
                    if (this.data.array.length ===0){
                        return true
                    } else {
                        return false
                    }
                }
            },
            handleSubmitClick () {
                this.$emit('btnSubmitClick')
            },
            handleApprovalClick () {
                this.$emit('btnApprovalClick')
            },
            handleRecallClick () {
                this.$emit('btnRecallClick')
            },
            handleCompleteClick () {
                this.$emit('btnCompleteClick')
            },
            handleAgreeClick () {
                this.$emit('btnAgreeClick')
            },
            handleRefuseClick () {
                this.$emit('btnRefuseClick')
            },
            handleRepealClick () {
                this.$emit('btnRepealClick')
            },
            handleSaveClick () {
                this.$emit('btnSaveClick')
            },
            handleDeleteClick () {
                this.$emit('btnDeleteClick')
            },
            handleCalculateDataClick () {
                this.$emit('btnCalculateDataClick')
            },
            handleBackClick () {
                this.$emit('btnBackClick')
            },
            handleAddClick (){
                this.$emit('btnAddClick')
            },
           async getCheckListById(obj){

                let data =obj
                data.tenant_id = this.$store.getters.getUser.user_id
                data.id =obj.activity_id
                data.user_id = obj.created_by
                data.date = moment().format('YYYY-MM-DD')
               await http.post('/wapi/Conference/getCheckListById',data).then(res=>{

               })
            },

        }
    }
</script>
<style lang="scss" module>
    @import '../assets/css/default';
    .container {
        .top {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            li {
                color:#000000;
                text-align:left;
                font-size: $TopTitleFontSize;
                .arrow {
                    font-size: $TopTitleFontSize;
                    color: #babac2;
                    vertical-align: bottom;
                }
            }
            .active {
                color: #59a8f9;
            }
        }
        .title {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            font-size:$TopSubFontSize;
            color:#000000;
            text-align:left;
            margin: 0px 0px;
            /*border-bottom:2px dotted #e7eaec;*/
            .name {
                color: #3b99f7;
                display: inline-block;
                font-size: 20px;
                margin-top: 20px;
                margin-bottom: 10px;
            }
            .back {
                color: #fff;
                font-size: 16px;
            }
        }
        .box{
            /*display: flex;*/
            /*flex-direction: row;*/
            /*flex-wrap: nowrap;*/
            /*justify-content: space-between;*/
            /*align-items: center;*/
            font-size:$TopSubFontSize;
            color:#000000;
            text-align:left;
            margin: 10px 0px;
            /*border-bottom:2px dotted #e7eaec;*/
            .boxContent{
                display: flex;
                justify-content: space-between;
                .level{
                    color: #7ED321;
                    font-size: 14px;
                    margin-bottom: 10px;
                    margin-top: 0;
                    .site{
                        color: #87909A;
                        padding-left: 20px;
                    }
                    .clientele{
                        color: #FF9901;
                    }
                }
            }
            .dataStatus{
                font-size: 16px;
                color: #87909A;
                margin-bottom: 10px;
                margin-top: -10px;
                .clientele{
                    color: #FF9901;
                    padding: 0 10px;
                }
                .clientele2{
                    color: #ED3B3F;
                    padding: 0 10px;

                }
            }

        }
    }
</style>
<style scoped>
    #delete{
        color: #FFF;
        background-color: #ED3B3F;
        border-color: #ED3B3F;
    }
    #delete:hover{
        color: #FFF;
        background-color: #f56c6c;
        border-color: #f56c6c;
    }
    #submit {
        color: #FFF;
        background-color: #FF9901;
        border-color: #FF9901;
    }
    #submit:hover {
        background: #ebb563;
        border-color: #ebb563;
        color: #FFF;
    }
    .el-button{
        font-size: 13px;
    }
    .el-button--small {
        padding: 9px 12px;
    }
    .icon {
        height: 33px;
        position: relative;
        top: 1px;
        padding: 7px 12px;
    }
    .icon >>> span{
        position: relative;
        top: -1px;
    }
</style>





// WEBPACK FOOTER //
// src/components/meetBar.vue